<div class="outside-background"
     (click)="onClose()"></div>

<div class="overlay-sidebar card flex vertical"
     @sidebarAnimation>

  <div class="flex center flex-0">
    <div class="flex-1">
      <h2 class="capitalize">{{sidebarTitle}}</h2>
    </div>
    <div class="flex-0">
      <button (click)="onClose()"><i class="fa fa-close"></i>Close</button>
    </div>
  </div>

  <div [id]="sidebarContentId"
       class="flex-1 flex vertical custom-max-height">
    <ng-content></ng-content>
  </div>

</div>
